import * as yup from "yup";
import { hasRichTextContent } from "./helpers";

function buildLocalizedRequiredShape(activeIsos = [], label = "Field") {
  const requiredIsos = activeIsos.includes("en")
    ? ["en"]
    : activeIsos.length
      ? [activeIsos[0]]
      : [];
  return activeIsos.reduce((acc, iso) => {
    acc[iso] = requiredIsos.includes(iso)
      ? yup.string().test(
          `${label}-${iso}-required`,
          `${iso.toUpperCase()} ${label} is required.`,
          (value) => hasRichTextContent(value),
        )
      : yup.string().nullable().transform(() => "");
    return acc;
  }, {});
}

export function buildTourSectionValidationSchema(activeIsos = []) {
  return yup.object({
    sections: yup.array().of(
      yup.object({
        title: yup
          .object()
          .shape(buildLocalizedRequiredShape(activeIsos, "title")),
        iconName: yup.string().trim().required("Icon is required."),
        imageUrl: yup.string().trim().required("Image is required."),
        descriptions: yup
          .object()
          .shape(buildLocalizedRequiredShape(activeIsos, "description")),
        items: yup
          .array()
          .of(
            yup.object({
              itemType: yup.string().trim().required("Type is required."),
              title: yup
                .object()
                .shape(buildLocalizedRequiredShape(activeIsos, "title")),
              location: yup.string().trim().required("Location is required."),
              rating: yup
                .number()
                .transform((value, originalValue) =>
                  String(originalValue || "").trim() === "" ? null : value,
                )
                .nullable()
                .min(0, "Rating must be 0.0 or greater."),
              websiteUrl: yup
                .string()
                .trim()
                .url("Website URL must be valid.")
                .required("Website URL is required."),
              imageUrl: yup.string().trim().required("Image is required."),
            }),
          )
          .default([]),
      }),
    ),
  });
}
